import { normalizeVisibleStatus } from "../../lib/statuses";

const statusClassNames = {
  Booked: "border border-zinc-200 bg-zinc-100 text-zinc-700",
  Assigned: "border border-sky-200 bg-sky-50 text-sky-700",
  Picked: "border border-orange-200 bg-orange-50 text-orange-700",
  Unassigned: "border border-zinc-200 bg-zinc-100 text-zinc-700",
  Scheduled: "border border-blue-200 bg-blue-50 text-blue-700",
  "In Transit": "border border-orange-200 bg-orange-50 text-orange-700",
  Delivered: "border border-green-200 bg-green-50 text-green-700",
  Invoiced: "border border-purple-200 bg-purple-50 text-purple-700",
  Canceled: "border border-rose-200 bg-rose-50 text-rose-600",
};

export const StatusBadge = ({ status, testId }) => {
  const visibleStatus = normalizeVisibleStatus(status);
  return (
  <span
    className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold ${statusClassNames[visibleStatus] || statusClassNames.Unassigned}`}
    data-testid={testId || `status-badge-${String(visibleStatus).toLowerCase().replace(/\s+/g, "-")}`}
  >
    {visibleStatus}
  </span>
  );
};